import React, { Component } from 'react'
import Img from 'gatsby-image'

export default class SidePhoto extends Component {
  constructor(props) {
    super(props)

    this.state = {
      height: this.calcHeight(),
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.setHeight)
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.setHeight)
    }
  }

  setHeight = () => this.setState({ height: this.calcHeight() })

  calcHeight = () =>
    typeof window !== 'undefined'
      ? window.innerHeight - (this.props.minusHeight || 0)
      : 500

  render() {
    return (
      <Img
        fadeIn={true}
        style={{
          height: this.state.height,
          ...this.props.style,
        }}
        sizes={this.props.sizes}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/sidePhoto.js